export default "__VITE_ASSET__25mHLd0b__"